import tripEvents from './../../config/events.constant';

export default function TripDetailsOrderListController(
    $rootScope,
    $scope,
    $state,
    $location,
    $anchorScroll,
    l10nService,
    tripItemCancellationMessageService
) {
    'ngInject';
    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        vm.cancellation = $scope.tripDetailsCtrl.cancellation;
    }

    let currentItem;

    $scope.cancelAlert = {
        visible: false,
        type: 'success',
        msg: '',
        show: function(isShow, type, msg) {
            this.visible = isShow;
            this.type = type ? type : this.type;
            this.msg = msg ? msg : this.msg;
        },
    };

    $scope.$on(tripEvents.TRIP_CANCEL_ITEM, (event, item) => {
        if ($rootScope.readOnlyMode) {
            $state.go('login');
        }

        tripItemCancellationMessageService.removeMessage(vm.cancellation);
        currentItem = item;

        vm.cancellation.cancellationMsg = {};
        if (currentItem.status === 'Quote' || currentItem.status === 'Held') {
            vm.cancellation.cancellationItemMsg = {
                message: true,
                quote: true,
                isRefundable: true,
                item,
            };
        }

        if (currentItem.status === 'Confirmed') {
            vm.cancellation.cancellationItemMsg = {
                message: true,
                confirmed: true,
                isRefundable: item.isRefundable !== false,
                item,
               };
        }
    });

    $scope.scrollTo = function(hash) {
        $location.hash(hash);
        $anchorScroll();
        $location.hash('');
    };

    $scope.history = createHistoryArray();

    function createHistoryArray() {
        const tripDetails = $scope.tripDetails;
        const result = [];

        if (tripDetails.LastEditUserFullName) {
            result.push({
                label: 'Last edited by',
                name: tripDetails.LastEditUserFullName,
                date: tripDetails.LastEditDate,
            });
        }
        if (tripDetails.CancelUserFullName) {
            result.push({
                label: 'Cancelled by',
                name: tripDetails.CancelUserFullName,
                date: tripDetails.CancelDate,
            });
        }
        if (angular.isDefined(tripDetails.ApprovalDetails)) {
            _.each(tripDetails.ApprovalDetails, function(approval) {
                if (approval.ApproveUserFullName) {
                    result.push({
                        label: 'Approved by',
                        name: approval.ApproveUserFullName,
                        date: approval.ApproveDate,
                        ruleLabel: approval.RuleLabel === null ? null : '- ' + approval.RuleLabel,
                    });
                }
                if (approval.DeclineUserFullName) {
                    result.push({
                        label: 'Declined by',
                        name: approval.DeclineUserFullName,
                        date: approval.DeclineDate,
                        ruleLabel: approval.RuleLabel === null ? null : '- ' + approval.RuleLabel,
                    });
                }
            });
        }

        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/details/tripDetailsOrderListController.js